import { FtuByVenueTotal } from 'apis/merchant-gateway/insights';

export type FtuByVenueTotalItem = Omit<
  FtuByVenueTotal,
  | 'firstTimeAvgBasketSizeWithVat'
  | 'firstTimeAvgBasketSizeNoVat'
  | 'returningAvgBasketSizeWithVat'
  | 'returningAvgBasketSizeNoVat'
> & {
  id: string;
  venueName: string;
  firstTimeAvgBasketSize: number;
  returningAvgBasketSize: number;
  currency: Currency;
};

export enum FtuByVenueTableColumnIDs {
  VENUE = 'VENUE',
  FIRST_TIME_CUSTOMERS_COUNT = 'FIRST_TIME_CUSTOMERS_COUNT',
  RETURNING_CUSTOMERS_COUNT = 'RETURNING_CUSTOMERS_COUNT',
  FIRST_TIME_AVG_BASKET_ITEMS = 'FIRST_TIME_AVG_BASKET_ITEMS',
  RETURNING_AVG_BASKET_ITEMS = 'RETURNING_AVG_BASKET_ITEMS',
  FIRST_TIME_AVG_BASKET_SIZE = 'FIRST_TIME_AVG_BASKET_SIZE',
  RETURNING_AVG_BASKET_SIZE = 'RETURNING_AVG_BASKET_SIZE',
}
export type FtuByVenueTableSortableColumnIDs = Exclude<FtuByVenueTableColumnIDs, FtuByVenueTableColumnIDs.VENUE>;
